//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoAvatarColors from './demos/DemoAvatarColors.vue'
import DemoAvatarInitials from './demos/DemoAvatarInitials.vue'
import DemoAvatarSizes from './demos/DemoAvatarSizes.vue'
import DemoAvatarIcons from './demos/DemoAvatarIcons.vue'
import DemoAvatarRounded from './demos/DemoAvatarRounded.vue'
import DemoAvatarTile from './demos/DemoAvatarTile.vue'
import DemoAvatarImages from './demos/DemoAvatarImages.vue'
import DemoAvatarGroup from './demos/DemoAvatarGroup.vue'

// code
// eslint-disable-next-line object-curly-newline
import {
  avatarColors,
  avatarInitials,
  avatarSizes,
  avatarIcons,
  avatarRounded,
  avatarTile,
  avatarImages,
  avatarGroup,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoAvatarColors,
    DemoAvatarInitials,
    DemoAvatarSizes,
    DemoAvatarIcons,
    DemoAvatarRounded,
    DemoAvatarTile,
    DemoAvatarImages,
    DemoAvatarGroup,
  },
  setup() {
    return {
      codeSnippets: {
        avatarColors,
        avatarSizes,
        avatarIcons,
        avatarRounded,
        avatarTile,
        avatarImages,
        avatarInitials,
        avatarGroup,
      },
    }
  },
}
